import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DetectDominantLanguage } from "../schemas/schemas_0";
export { $Command };
export class DetectDominantLanguageCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("Comprehend_20171127", "DetectDominantLanguage", {})
    .n("ComprehendClient", "DetectDominantLanguageCommand")
    .sc(DetectDominantLanguage)
    .build() {
}
